import { useState } from 'react';
import { feeds } from '@/mocks/homeData';
import SectionHead from './SectionHead';

const filters = ['全部', '影视圈', '综艺圈', '饭圈', '音乐圈', '时尚圈', '运营圈'];

function FeedCard({ item }: { item: (typeof feeds)[number] }) {
  return (
    <a
      href="#flash"
      className="group flex flex-row overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-background-300"
    >
      <div className="relative w-2/5 shrink-0 overflow-hidden bg-background-100 sm:w-[180px]">
        <img
          src={item.img}
          alt={item.title}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 inline-flex rounded-full bg-foreground-950/80 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {item.tag}
        </span>
      </div>
      <div className="flex flex-1 flex-col justify-center p-3.5 md:p-4">
        <h3 className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-950 group-hover:text-primary-600 md:text-[15px]">
          {item.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 text-[13px] leading-relaxed text-foreground-500 hidden sm:block">{item.sum}</p>
        <div className="mt-2.5 flex items-center gap-3 text-xs text-foreground-400">
          <span className="inline-flex items-center gap-1"><i className="ri-time-line"></i>{item.time}</span>
          <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>{item.views}w 阅读</span>
        </div>
      </div>
    </a>
  );
}

export default function Feed() {
  const [active, setActive] = useState('全部');
  const shown = active === '全部' ? feeds : feeds.filter((f) => f.tag === active);

  return (
    <section id="flash" className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <SectionHead
          anchorId="flash"
          kicker="Daily · 图文短讯流"
          title="五一黑料图文速递"
          desc="每日手动整理的热点切片，短平快、信息量大，图文版一网打尽。"
          href="#flash"
          accent="primary"
        />
        <div className="mb-5 flex flex-wrap gap-2">
          {filters.map((f) => (
            <button
              key={f}
              onClick={() => setActive(f)}
              className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-[13px] font-medium transition-colors ${
                active === f ? 'bg-primary-500 text-background-50' : 'bg-background-50 text-foreground-700 hover:bg-background-200/70'
              }`}
            >
              {f}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {shown.map((item, i) => (
            <FeedCard key={i} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}